import React, { useState } from "react";

const HelpCenterFaq = ({FaqItemsList}) => {
  
    const [activeFaq, setActiveFaq] = useState();

    const toggleFaq = (id) => {
      if (activeFaq === id) {
        setActiveFaq(null);
      } else {
        setActiveFaq(id);
      }
    };
  return (
    <>
      <div
        className="accordion text-start popular-article-accordion"
        id="faqAccordion"
      >
        {FaqItemsList.map((item, index) => (
          <div
            className={`accordion-item mb-12 bg-white ${
              activeFaq === item.id ? "active-border" : ""
            }`}
            key={index}
          >
            <h2 className="accordion-header" id={`heading${item.id}`}>
              <button
                className={`accordion-button ah-text-md fw-bold p-16 text-black bg-white ${
                  activeFaq === item.id ? "" : "collapsed"
                }`}
                type="button"
                onClick={() => toggleFaq(item.id)}
              >
                {item.question}
              </button>
            </h2>
            <div
              id={`collapse${item.id}`}
              className={`accordion-collapse collapse ${
                activeFaq === item.id ? "show" : ""
              }`}
            >
              <div className="accordion-body ah-text-sm fw-normal black-100-60 p-16 pt-0">
                {item.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default HelpCenterFaq;
